<template>
  <div class="index">
    <div v-wechat-title="$route.meta.title"></div>
    
    <!-- Loading 覆盖层 -->
    <van-overlay :show="isLoading" class="loading-overlay">
      <div class="loading-content">
        <van-loading size="24px" color="#007AFF">{{ loadingText }}</van-loading>
      </div>
    </van-overlay>
    
    <van-cell v-if="cooperative=='0'" class="nick_topTip" is-link @click="showPopup" v-show="nickShow">切换账号</van-cell>
    <van-cell v-if="cooperative=='1'" class="nick_topTip" is-link right-icon="arrow" @click="gotoOrderList">交易列表</van-cell>
    <switchCard ref="child" ></switchCard>
    <div class="index-banner" v-if="cooperative=='0'">
     <span v-if="!zyhtBol">
       <img v-if="userTopName==null" src="@/assets/logo2@2x.png">
       <div v-else class="topFan">{{userTopName}}</div>
     </span>
      <img v-else src="@/assets/zyhtLogoIndex.png">
      <div class="station-name">{{stationName}}</div>
      <div class="cashier-name">收银员：{{GET_USER.truename}}</div>
    </div>
    <div class="index-banner" v-if="cooperative=='1'">
      <img v-if="userTopName==null" src="@/assets/logo2@2x.png">
      <div v-else class="topFan">{{userTopName}}</div>
      <div class="station-name">{{stationName}}</div>
      <div class="cashier-name">收银员：{{GET_USER.truename}}</div>
    </div>
    <div class="index-content">
      <IndexItem v-if="cooperative=='0'" :itemArr="itemArr"/>
      <CooperativeIndexItem  :classifyAuth="classifyAuth" :stationOilUnit="stationOilUnit" v-if="cooperative=='1'" :itemArr="itemArr"/>
    </div>
    <div v-if="cooperative=='0'" class="index-button">
      <div class="btn-lr" @click="$router.push('/orderList')">
        <img src="@/assets/trade-list@2x.png">
        <div>交易列表</div>
      </div>
      <div class="btn-mid" @click="checkHasPaying">
        <img src="@/assets/scan-code@2x.png">
        <div>扫码收款</div>
      </div>
      <div class="btn-lr test-right" @click="$router.push('/mine')">
        <img src="@/assets/p-center@2x.png">
        <div>账号设置</div>
      </div>
    </div>
    <div   v-if="cooperative=='1'" class="cooperative-button"  @click="$router.push('/mine')">
      <img src="@/assets/p-center@2x.png">
    </div>
    <van-popup v-model="showPassModal" class="contentPassword" :close-on-click-overlay="false">
      <div class="passTitle">修改密码</div>
      <div class="passTip">*密码由8-20位大小写字母和数字</div>

      <van-form validate-trigger="onSubmit" @submit="onSubmit" class="pwd-field">
        <van-field
          center
          v-model="old_password"
          name="old_password"
          required
          :type="iconList.old_password_icon =='eye-o'?'text':'password'"
          label="当前密码"
          placeholder="请输入当前密码"
          label-class="label-style"
          :right-icon="iconList.old_password_icon"
          @click-right-icon="toggleIcon('old_password_icon')"
          clearable
        />
        <van-field
          center
          v-model="password"
          name="password"
          label="设置新密码"
          required
          placeholder="请输入新密码"
          :type="iconList.password_icon =='eye-o'?'text':'password'"
          label-class="label-style"
          :right-icon="iconList.password_icon"
          @click-right-icon="toggleIcon('password_icon')"
          clearable
          :rules="[{ pattern, message: '密码须包含大小写字母,数字且不少于8位' }]"
        />
        <van-field
          center
          v-model="re_password"
          name="re_password"
          label="确认新密码"
          required
          placeholder="请再次输入新密码"
          label-class="label-style"
          :type="iconList.re_password_icon =='eye-o'?'text':'password'"
          :right-icon="iconList.re_password_icon"
          @click-right-icon="toggleIcon('re_password_icon')"
          clearable
          :rules="[{ pattern, message: '密码须包含大小写字母,数字且不少于8位' },{ validator, message: '两次输入密码不一致' }]"
        />
        <div class="btnBoxAdd">
          <van-button type="info" class="back-index enterAccont"   :disabled="!btnCanuse"  native-type="submit">确定修改</van-button>
          <span class="noneEnter" @click="confimnone">暂不修改</span>
        </div>
      </van-form>
    </van-popup>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant';
import IndexItem from '@/components/IndexItem.vue'
import CooperativeIndexItem from '@/components/CooperativeIndexItem.vue'
import switchCard from'@/components/switchCard'
import wx from 'weixin-js-sdk'
import { stationInfoApi, orderListApi,checkOrderApi,getCooperateList } from '@/api/station';
import { mapGetters, mapActions } from 'vuex';
import { MODIFY_STATIONINFO } from '@/store/station';
import { jsSdkApi ,decodeQRApi } from '@/api/user';
import { isIos, isWeixin } from "@/utils/tools"
import { editPwdApi } from '@/api/user';
import { js_secret,generateRandomString } from '../utils/tools'
import urlencode from "../utils/urlencode";

// import Speech from 'speak-tts'


export default {
  name: 'Index',
  data(){
    return {
      itemArr: [],
      cooperative:localStorage.getItem('cooperative')==2?'1':'0',
      old_password:'',
      pattern: /^(?=.*[A-Za-z])(?=.*[0-9])[^]{6,}$/,
      re_password:'',
      password:'',
      classifyAuth:'1',
      stationOilUnit:'2',
      showPassModal:false,
      zyhtBol:window.location.href.indexOf('hbgszyht')>-1,
      stationName: '',
      newPassObj:{
        oldPass:'',
        newPass:'',
        new_re_Pass:''
      },
      nickShow:false,
      switchList:[],
      throttleFlag: false, //节流标识
      userTopName:null,
      iconList:{
        old_password_icon:'closed-eye',
        password_icon:'closed-eye',
        re_password_icon:'closed-eye',
      },
      isLoading: false,
      loadingText: '加载中...',
      pendingRequests: 0
    }
  },
  created(){
    console.log('created',this.cooperative)
  },
  mounted(){
    const  pwd_switch  = window.localStorage.getItem('pwd_switch')||'false';
    console.log('pwd_switch-------',pwd_switch);
    if (pwd_switch=='true') {
       this.showPassModal = true
    }else{
       this.showPassModal = false
    }
    /*-----调试信息-勿删-----*/
    // let speech = new Speech()
    // speech.setLanguage('zh-CN')
    // speech.init().then((data)=>{
    // }).catch(e => {
    //   console.error("An error occured while initializing : ", e)
    // })
    // speech.speak({text:"收款203230元"}).then(()=>{
    //   console.log("读取成功")
    // })
    // this.voicePrompt('皮卡丘皮卡丘皮卡丘皮卡丘');

    // this.$router.push({
    //   path:'/charge',
    //   query:{
    //     token: 'afe7233d-873f-404c-9fd4-ee1c18a3dee0',
    //     station_id: 'b97827aaf05a11ebba94ce92ba6948a1'
    //   }
    // })
    // console.log(window.location.search.split('=')[1])
    /*-----调试信息------*/
    
    if(isWeixin()){
      this.getUsin()
    }
    
    // 开始加载
    this.isLoading = true
    this.loadingText = '加载中...'
    this.pendingRequests = 2
    
    this.getStationInfoAjax()
    this.getOrderInfoAjax()
    const _this = this;
    if(window.location.search.split('=')[1]=='resetCode'){
      _this.callCamera();
    }

  },
  methods:{
    // 处理请求完成，管理loading状态
    handleRequestComplete() {
      this.pendingRequests--
      if (this.pendingRequests <= 0) {
        this.isLoading = false
        this.pendingRequests = 0
      }
    },
    gotoOrderList(){
      this.$router.push('/CooperativeOrderList')
    },
    confimnone(){
      this.showPassModal=false;
      window.localStorage.setItem('pwd_switch','false')
    },
    toggleIcon(item){
      if(this.iconList[item] === 'closed-eye'){
        this.iconList[item] = 'eye-o'
      }else{
        this.iconList[item] = 'closed-eye'
      }
    },
    validator(val) {
      return this.compare_val;
    },
    onSubmit(values) {
      const redomStr = generateRandomString();
      let params={
        id:this.GET_USER.id,
        re_password: urlencode(js_secret(values.re_password,redomStr)),
        password:urlencode(js_secret(values.password,redomStr)),
        old_password:urlencode(js_secret(values.old_password,redomStr)),
        characters:redomStr
      }
      editPwdApi(params).then(res => {
        if (res.code === 0) {
          Toast('密码修改成功');
          this.confimnone();
          this.USER_SIGNOUT();
          setTimeout(() => {
            let gas_token = localStorage.getItem('gas_token');
            if(gas_token){
              if(location.href.indexOf('test') > -1 || location.href.indexOf('172.') > -1) {
                window.location.href = 'https://gas.test.chinawayltd.com/gas_android/'
              } else {
                window.location.href = 'https://gas.huoyunren.com/gas_android/'
              }
            }else {
              this.$router.replace('/login')
            }
          }, 1000)
        } else {
          Toast(res.msg);
        }
      }).catch(err => {
        console.log(err.message)
      })
    },
    ...mapActions([MODIFY_STATIONINFO]),
    fakeingStr(str,index){
      const _this = this;
      for(let i = str.length;i>=0;i--){
        if('东'.indexOf(str[i])>=0){
          _this.userTopName = str[i]
          break ;
        }else if('南'.indexOf(str[i])>=0){
          _this.userTopName = str[i]
          break ;
        }else if('西'.indexOf(str[i])>=0){
          _this.userTopName = str[i]
          break ;
        }else if('北'.indexOf(str[i])>=0){
          _this.userTopName = str[i]
          break ;
        }else{
          _this.userTopName  = null
        }
      }
      console.log(_this.userTopName);
    },
    showPopup(){
      this.$refs.child.callMethod()
    },
    showGrop(){
      this.nickShow = true;
    },
    getStationInfoAjax(){
      let params = {id: this.GET_USER.station_id}
      stationInfoApi(params).then(res=>{
        if (res.code === 0 ){
          this.stationName = res.data[0].remark_name || res.data[0].station_name;
          this.fakeingStr(this.stationName)
          let card_classify = res.data[0].allow_switch_unit
          let stationOilUnit =  res.data[0].station_oil_unit
          this.classifyAuth = card_classify.toString()
          this.stationOilUnit = stationOilUnit.toString()
          //  ？？？？
          let vuexParam = {
            stationName: this.stationName,
            classifyAuth: card_classify,
            stationOilUnit: stationOilUnit
          }
          this.MODIFY_STATIONINFO(vuexParam);
        } else {
          console.log(res.msg)
        }
      }).catch(err => {
        console.log(err.message)
      }).finally(() => {
        this.handleRequestComplete()
      })
    },
    getOrderInfoAjax(){
      let params = {
        station_id: this.GET_USER.station_id,
        limit: this.cooperative == '1' ? '' : 2
      }
      if(this.cooperative == '1'){
        getCooperateList(params).then(res=>{
          if (res.code === 0){
            this.itemArr = res.data.data
          }else {
            Toast(res.msg);
          }
        }).catch(err => {
          console.log(err.message)
        }).finally(() => {
          this.handleRequestComplete()
        })
      }else{
        orderListApi(params).then(res=>{
          if (res.code === 0){
            this.itemArr = res.data.data
          }else {
            Toast(res.msg);
          }
        }).catch(err => {
          console.log(err.message)
        }).finally(() => {
          this.handleRequestComplete()
        })
      }
    },
    checkLatestOrder(){
      let params = {
        station_id: this.GET_USER.station_id,
      }
      checkOrderApi(params).then(res=>{
        if (res.code === 3106403051005){
          Dialog.confirm({
            message: '该站点有一笔订单收款未成功！\n请先完成上笔订单',
            width: '8.5333rem',
            confirmButtonText:'继续扫码收银',
            confirmButtonColor:'#532FE6',
            cancelButtonText:'查看该笔订单',
            cancelButtonColor:'#333',
            className:'dialog-style'
          }).then(() => {
            this.callCamera();
          }).catch(() => {
            this.$router.push('/orderList')
          });
        }else if (res.code === 0){
          this.callCamera()
        }else {
          Toast(res.msg);
        }
      }).catch(err => {
        console.log(err.message)
      })
    },

    checkHasPaying(){
        let _this = this
        if(localStorage.getItem('camera') === '1'){
            if (this.throttleFlag){
                Toast('请求频繁，请稍后再试')
                return false
            }
            this.throttleFlag = true
            // 5秒置为false，可以再次调起摄像头
            setTimeout(function () {
                _this.throttleFlag = false
            },5000)
            // this.checkLatestOrder();
            this.callCamera();
        }else{
            Dialog.confirm({
                title: 'G7能源申请访问您的相机',
                message: '用于加油记账、加油记账撤销',
                confirmButtonText:"允许",
                cancelButtonText:"拒绝",
            }).then(() => {
                if (this.throttleFlag){
                    Toast('请求频繁，请稍后再试')
                    return false
                }
                localStorage.setItem('camera', '1')
                this.throttleFlag = true
                // 5秒置为false，可以再次调起摄像头
                setTimeout(function () {
                    _this.throttleFlag = false
                },5000)
                // this.checkLatestOrder();
                this.callCamera();
            }).catch(() => {

            })
        }
    },
    test(code, res) {
      console.log(res, '111111')
      console.log(code, 'code')
    },
    getUsin(){
      let url = isIos() ? encodeURIComponent(window.entryUrl) : encodeURIComponent(location.href.split('#')[0]);
      console.log('签名url---',url);
      jsSdkApi({url:url}).then(res => {
          let configData = res.data
          console.log('configData-----',configData);
          setTimeout(()=>{
            wx.config({
              debug: false,
              appId: configData.app_id,
              timestamp: configData.timestamp.toString(),
              nonceStr: configData.noncestr,
              signature: configData.signature,
              jsApiList:["scanQRCode","chooseImage","getLocalImgData","uploadImage","downloadImage"]
            })
            wx.error(function (e) {
              console.log('js-sdk 配置失败')
              console.log('e----首页----',e)
              //Toast('js-sdk 配置失败')
            })
          },1000)
      }).catch(function (error) {
        console.log(error);
      });
    },
    callCamera(){
      let url = isIos() ? encodeURIComponent(window.entryUrl) : encodeURIComponent(location.href.split('#')[0]);
      let _this = this;
      if(isWeixin()) {
        wx.ready(()=>{
            wx.checkJsApi({ // 判断当前客户端版本是否支持指定JS接口
                jsApiList: ['scanQRCode'],
                success: function (res) {
                    if (res.checkResult.scanQRCode === true) {
                        wx.scanQRCode({
                            needResult: 1,
                            scanType: ['qrCode', 'barCode'],
                            success: function (res) {
                              let getCodeRes = res.resultStr||null;
                              console.log('微信解析二维码getCodeRes===',getCodeRes,'res====',res);
                              if(getCodeRes==null){
                                  Dialog.alert({
                                    message: '扫描二维码失败，请重试！',
                                  }).then(() => {
                                    // on close
                                  });
                                }else{
                                  _this.dealWithQr(getCodeRes);
                                }

                            }
                        })

                    }else{
                        Dialog.alert({
                            message: '抱歉，当前客户端版本不支持扫一扫',
                        }).then(() => {
                            // on close
                        });
                    }
                },
                fail: function (res) {
                    console.log('fail' + res)
                }
            })
        })
      } else {
          window.remote = {
              inputBackCallbackFunc: (code, qrcode) => {
                let getCodeRes = qrcode||null;
                console.log('PDA解析出来qrcode====',qrcode);
                if(getCodeRes==null){
                  Dialog.alert({
                    message: '扫描二维码失败，请重试！',
                  }).then(() => {
                    // on close
                  });
                }else{
                  _this.dealWithQr(getCodeRes);
                }
              }
          };
          native.scanBarCode('remote.inputBackCallbackFunc');
      }
    },
    dealWithQr(qr_code) {//扫码付款
         const _this = this;
          decodeQRApi({qr_code}).then(res=>{
              if(res && res.code === 0){
                  const token = res.data.token
                  _this.$router.push({
                      path:'/charge',
                      query:{
                          token: token,
                          station_id: _this.GET_USER.station_id
                      }
                  })
                  //return;
              }else{
                  _this.$router.push({
                      name:'scanError',
                      params:{
                          errorMsg: res.msg
                      }
                  })
                  //Toast(res.msg);
              }
          }).catch(err => {
              console.log(err.message)
          })
      }
  },
  computed:{
    ...mapGetters(["GET_USER"]),
    compare_val(){
      return this.password === this.re_password
    },
    btnCanuse(){
      return this.old_password!=='' && this.password!=='' && this.re_password!==''
    }
  },
  components: {
    IndexItem ,switchCard,CooperativeIndexItem
  }

}
</script>
<style>

</style>
<style lang="less" scoped>
    .cooperative-button{
      width: 50px;
      position: absolute;
      right: 15px;
      bottom: 20px;
      img{
        width: 50px;
        height: 50px;
      }
    }
    .noneEnter{
        font-size: 12px;
        color: #555555;
        position: absolute;
        left: 10px;
        top: 20px;
    }
    .passTitle{
        font-size: 16px;
        text-align: center;
        font-weight:700 ;
        margin: 10px 0;
    }
    .passTip{
        font-size: 14px;
        text-align: center;
    }
    .btnBoxAdd{
        text-align: center;
        margin-top: 20px;
        position: relative;
    }
    .enterAccont{
        background: linear-gradient(90deg, #7e60ff 0%, #532fe6 100%);
        border: none;
    }
    .contentPassword{
        width: 346px;
        height: 400px;
        border-radius: 10px;
        /deep/ .van-cell{
            padding: 23px;
        }
    }
  .topFan{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    vertical-align: top;
    font-size: 30px;
    font-weight: 700;
    background: #ffff;
    display: inline-block;
    line-height: 47px;
    text-align: center;
    color: #6746f2;
  }
  .index{
    /deep/.van-cell::after{
      border: none !important;
    }
    
    // Loading 覆盖层样式
    .loading-overlay {
      /deep/ .van-overlay {
        background: rgba(0, 0, 0, 0.5);
      }
      
      .loading-content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 20px;
        background: white;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        
        /deep/ .van-loading {
          .van-loading__text {
            color: #333;
            font-size: 14px;
            margin-top: 8px;
          }
        }
      }
    }
    
    .nick_topTip{
      width: 90px;
      position: absolute;
      right: 0px;
      padding: 7px;
      background: #fff0;
      /deep/ .van-cell__value{
        color: #fff;
        white-space: nowrap;
      }
    }
    min-height: 100vh;
    .index-banner{
      height: 177px;
      background: linear-gradient(270deg, #7E60FF 0%, #532FE6 100%);
      padding-top: 20px;
      text-align: center;

      img{
        display: block;
        margin: 0 auto;
        height: 70px;
        width: 70px;
      }
      .station-name{
        height: 25px;
        line-height: 25px;
        font-size: 18px;
        color: #fff;
        margin-top: 8px;
        font-weight: 500;
        padding: 0 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow:ellipsis;
      }
      .cashier-name{
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        color: #fff;
        margin-top: 4px;
      }
    }
    .index-content{
      margin-top: -10px;
      border-radius: 10px 10px 0 0;
      background: #F2F2F2
    }
    .index-button{
      display: flex;

      padding: 0 40px;
      .btn-lr{
        flex: 1;
        align-self: flex-end;
        img{
          height: 45px;
          width: 45px;
        }
        div{
          color: #555555;
          font-size: 13px;
        }
      }
      .test-right{
        text-align: right;
      }
      .btn-mid{
        flex: 1;
        text-align: center;
        img{
          height: 70px;
          width: 70px;
        }
        div{
          color: #555555;
          font-size: 13px;
        }
      }
    }
  }
</style>
<style>
  .dialog-style .van-dialog__content .van-dialog__message{
    font-size: 17px;
    color: #333;
    padding: 31px 21px;
    line-height: 1.5;
  }
  .van-dialog__confirm{
    font-weight: 500;
  }
  .van-dialog{
    border-radius: 0.32667rem;
  }

</style>
